// for cloud
const apiUrl = "https://anlyeng.smartler.in/"; 
// for WFH
//const apiUrl = "http://111.93.227.212:8096/";

//const apiUrl = "http://13.234.144.120:8096/";
// for alpha site
//const apiUrl = "http://192.168.82.1:8096/";


//const apiUrl = "http://111.93.227.213:8096/";
//const apiUrl = "http://192.168.82.2:8096/";
//const apiUrl = "http://3.111.207.158:8096/";
export default apiUrl;
